// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"594fae12","455":"b603b09c","488":"070a9aa7","566":"d06618fb","602":"41fa8f19","607":"97928d3a","773":"d8de65a0","880":"f4589da9","990":"d6dad3fa"}[chunkId] + ".chunk.js";
};